import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UnitDisplayLedSettings } from '../models/navigation';

@Injectable({
  providedIn: 'root',
})
export class UnitWatchdogService {
  private httpClient = inject(HttpClient);
  private apiUrl = 'https://localhost/ajax/webApp';

  canUseSideLedIndication(unitDisplayAndLEDSetting?: UnitDisplayLedSettings | null): boolean {
    if (!this.isUserAgentFromUnit() || !unitDisplayAndLEDSetting) {
      return false;
    }

    if (unitDisplayAndLEDSetting.unitSideLEDIndicationSettingType === 0) {
      return true;
    }

    if (unitDisplayAndLEDSetting.unitSideLEDIndicationSettingType !== 2) {
      return false;
    }
    const now = new Date();
    const currentDay = this.getCurrentTimetableDay(now);
    const currentMinutes = now.getHours() * 60 + now.getMinutes();

    return (unitDisplayAndLEDSetting.unitSideLEDIndicationTimeTable?.timeTableSettings || []).some((slot) => {
      if (slot.day !== currentDay) {
        return false;
      }

      const startMinutes = this.parseTimeToMinutes(slot.periodStart);
      const endMinutes = this.parseTimeToMinutes(slot.periodEnd);
      if (startMinutes === null || endMinutes === null || endMinutes <= startMinutes) {
        return false;
      }

      return currentMinutes >= startMinutes && currentMinutes < endMinutes;
    });
  }

  sendInfoToWatchDog(isStarted: boolean) {
    const body = {
      started: isStarted,
    };

    return this.httpClient.post(this.apiUrl, body);
  }

  sendRequestDigitalSignageMediaLoad(signageId: string) {
    const body = {
      digitalSignageUrl: `${location.origin}/api/digitalSignage/public/${signageId}`,
    };

    return this.httpClient.post('https://localhost/ajax/digitalSignage', body);
  }

  switchToMediaLoadViaUnitMode(enableLoadViaUnitMode: boolean) {
    const body = {
      show: enableLoadViaUnitMode,
    };

    return this.httpClient.post('https://localhost/ajax/showDigitalSignage', body);
  }

  requestChangeLED(rgb: string) {
    const body = {
      colorRGB: rgb,
    };

    return this.httpClient.post('https://localhost/ajax/ledControl', body);
  }

  isUserAgentFromUnit(): boolean {
    const ua = navigator.userAgent || '';
    return ua.toLowerCase().includes('cue');
  }

  private getCurrentTimetableDay(now: Date): number {
    return (now.getDay() + 6) % 7;
  }

  private parseTimeToMinutes(value: string): number | null {
    if (!/^\d{2}:\d{2}$/.test(value)) {
      return null;
    }

    const [hours, minutes] = value.split(':').map((part) => parseInt(part, 10));
    if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
      return null;
    }

    return hours * 60 + minutes;
  }
}
